import { render } from "./Settings.vue?vue&type=template&id=ff183004&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=ff183004&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ff183004"

export default script